import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { Alert, Icon, Link } from '@/modules/ui';

import { useOverdueInvoiceAlert } from './hooks';
import * as felaRules from './OverdueInvoiceAlert.rules';

export const OverdueInvoiceAlert = () => {
    const { isOverdue, isLoggedUserAdmin, stripeAdminEmail } = useOverdueInvoiceAlert();

    if (!isOverdue) {
        return null;
    }

    return (
        <Alert
            showIcon
            icon={<Icon type='warning' width={20} height={20} />}
            size='fullWidth'
            customStyle={felaRules.container}
            message={
                isLoggedUserAdmin ? (
                    <FormattedMessage
                        id='settings.overdueInvoice.alert.admin'
                        values={{
                            link: chunks => (
                                <Link type='native' href={config.links.stripe} noreferrer inheritColor>
                                    {chunks}
                                </Link>
                            ),
                            b: chunks => <strong>{chunks}</strong>,
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id='settings.overdueInvoice.alert.user'
                        values={{
                            stripeAdminEmail: (
                                <Link type='native' href={`mailto:${stripeAdminEmail}`} noreferrer inheritColor>
                                    {stripeAdminEmail}
                                </Link>
                            ),
                            b: chunks => <strong>{chunks}</strong>,
                        }}
                    />
                )
            }
            type='error'
            data-testid='overdue-invoice-alert'
        />
    );
};
